import React, { useContext, useEffect, useState } from "react";


import { withTranslation } from "react-i18next";
import { getPayboxParameters } from "../../utils/requests/paybox";
import { MsalInstanceContext, VariablesContext } from "../../auth/AppProvider";
import * as FormsComponent from "../Inputs/forms/index";
import { PencilIcon, ReceiptPercentIcon } from "@heroicons/react/24/outline";
import LoadingSpinner from "../Animation/LoadingSpinner";
import Alert from "../Alert/Alert";
import { CompletionsContext } from "../../App";
const countrycodes = require('../../assets/countrycode.json');


const errorList = {
    "00000": " Opération réussie / Operation successful",
    "00001": "La connexion au centre d’autorisation a échoué ou une erreur interne est survenue / The connection to the authorization center has failed or an internal error has occurred",
    "00002": "Une erreur de cohérence est survenue / An inconsistency error has occurred",
    "00003": "Erreur Paybox / Paybox error",
    "00004": "Numéro de porteur ou cryptogramme visuel invalide / Invalid card number or visual cryptogram",
    "00006": "Accès refusé ou site/rang/identifiant incorrect / Access denied or incorrect site/rank/identifier",
    "00008": "Date de fin de validité incorrecte / Incorrect end date of validity",
    "00010": "Devise inconnue / Unknown currency",
    "00011": "Montant incorrect / Incorrect amount",
    "00012": "Référence commande invalide / Invalid order reference",
    "00013": "Cette version n’est plus soutenue / This version is no longer supported",
    "00014": "Trame reçue incohérente / Received frame inconsistent",
    "00015": "Émetteur de carte inconnu / Unknown card issuer",
    "00016": "Référence de paiement invalide / Invalid payment reference",
    "00021": "Carte non autorisée / Card not authorized",
    "00022": "Plafond atteint / Limit reached",
    "00029": "Carte non conforme / Non-compliant card",
    "99999": "",
    "00097": "Timeout de connexion atteint / Connection timeout reached",
    "00098": "Erreur de connexion interne / Internal connection error",
    "canceled": "Paiement annulé / Payment canceled",

}

const currencyList = [{ "option": "978", "label": "€" }, { "option": "840", "label": "$" }, { "option": "826", "label": "£" }]

function Paybox({ t, question, formId }) {
    const variables = useContext(VariablesContext)
    const msalInstance = useContext(MsalInstanceContext);
    const [errorShow, setErrorShow] = useState(false);
    const [payboxParameters, setPayboxParameters] = useState(false);
    const [formType, setFormType] = useState(false);
    const [lockInfo, setLockInfo] = useState(false);
    const [errors, setErrors] = useState(null);
    const [completions, setCompletions] = useContext(CompletionsContext);

    const [formBuyer, setFormBuyer] = useState({
        firstName: "",
        lastName: "",
        email: "",
        adress1: "",
        adress2: "",
        zipCode: "",
        city: "",
        country: ""
    })




    useEffect(() => {
        if (window.location.href.endsWith("/paid")) {
            setErrorShow(true);
        }
        var formTypeLoc = window.location.href.split("/")[3];

        setFormType(decodeURI(formTypeLoc));

    }, [])

    function getParameters() {
        var noteErrorId = null;
        if (completions) {
            var completion = completions.find(c => c.id === formId);
            noteErrorId = completion ? completion.noteErrorId : null;
        }
        setErrors(null);
        if (formBuyer.firstName === "" || formBuyer.lastName === "" || formBuyer.email === "" || formBuyer.adress1 === "" || formBuyer.zipCode === "" || formBuyer.city === "" || formBuyer.country === "") {
            setErrors("Veuillez remplir tous les champs obligatoires / Please fill in all required fields");
        } else {
            setLockInfo(true);
            setPayboxParameters(false);
            setErrorShow(false);
            getPayboxParameters(msalInstance, variables, formId, question.id, formBuyer, noteErrorId).then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    return res.json().then(err => {
                        throw err;
                    });
                }
            }).then(data => {
                setPayboxParameters(data);
            }).catch(err => {
                setErrors(err);
                setLockInfo(false);
            })
        }
    }



    return question ? <div>
        {question?.value === "paid" || question?.options[0]?.value === "0" ?
            <div className="mt-6">
                <Alert type="success" title={question?.options[0]?.value === "0" ? t("Commande gratuite / Free order") : t("Paiement réussi / Payment successful")}
                    description={question?.options[0]?.value === "0" ? t("Votre commande est entièrement gratuite ! Aucun paiement n'est requis. / Your order is completely free! No payment is required.") : t("Votre paiement a été validé par Paybox / Your payment has been validated by Paybox.")} />
            </div>
            : (question?.value === "waiting" ?
                <div className="mt-6">
                    <Alert type="info" title={t("En attente de paiement / Pending payment")} description={t("Nous attendons la réponse de Paybox concernant votre paiement. Revenez plus tard. / We are waiting for Paybox's response regarding your payment. Please check back later.")} />
                </div> : (errorShow ?
                    <div className="mt-6">
                        <Alert type="error" title={t("Une erreur est survenue lors de votre paiement / An error occurred during your payment")} description={errorList[question?.value]} />
                    </div>
                    : null))}
        {question?.value === "paid" || question?.options[0]?.value === "0" ? <div className="text-center items-center align-middle py-auto place-content-center text-2xl px-24 ">
            {/* Vous allez être redirigé vers la page de confirmation de votre commande dans quelques secondes... */}
        </div> : (question?.value !== "waiting" ? <div className="mt-6">
            {/* Récapitulatif de la commande */}
            <div className="p-4  mt-6 bg-gray-200/70">
                <div className="flex w-full">
                    <div className="shrink-0">
                        <ReceiptPercentIcon aria-hidden="true" className="size-5 text-gray-600" />
                    </div>
                    <div className="ml-3  w-full">
                        <div className="flex justify-between text-sm">
                            <div><h3 className="text-md font-medium">{t("Récapitulatif du paiement / Payment summary")}</h3></div>
                            <div className="">
                                <span className="text-black text-md font-bold">{question?.options[0]?.value ? (question?.options[0]?.value.slice(question?.options[0]?.value.length - 2) !== "00" ? [question?.options[0]?.value.slice(0, question?.options[0]?.value.length - 2), ",", question?.options[0]?.value.slice(question?.options[0]?.value.length - 2)].join('') : question?.options[0]?.value.slice(0, question?.options[0]?.value.length - 2)) : null}</span>
                                <span className="text-black text-md font-bold">{question?.options[1]?.value && currencyList.find(cL => cL.option === question?.options[1]?.value) ? currencyList.find(cL => cL.option === question?.options[1]?.value)?.label : null}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Formulaire de paiement */}
            <div className="mt-6">
                <form className="bg-white shadow-sm ring-1 ring-gray-900/5">
                    <div className="px-4 py-6 sm:p-8">
                        <div className="px-4 sm:px-0 flex justify-between">
                            <div><h2 className="text-base/7 font-semibold text-gray-900">Informations de facturation / Biling informations</h2>
                                {!lockInfo && <p className="mt-1 text-sm/6 text-gray-600">Veuillez renseigner vos informations pour la facturation pour finaliser votre commande / Please provide your billing information to complete your order</p>}
                            </div>
                            {lockInfo && <div>
                                <PencilIcon className="h-6 w-6 text-gray-500 cursor-pointer" onClick={() => setLockInfo(false)} />
                            </div>}
                        </div>
                        {!lockInfo ?
                            <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 mt-4">
                                {errors ? <div className="col-span-full text-red-500">{errors}</div> : null}
                                <div className="sm:col-span-3">
                                    <label htmlFor="first-name" className="block text-sm/6 font-medium text-gray-900">
                                        Prénom * / Firstname *
                                    </label>
                                    <div className="mt-2">
                                        <FormsComponent.Input id="firstName" label="Prénom" value={formBuyer.firstName} onChange={(e) => setFormBuyer({ ...formBuyer, firstName: e })} />
                                    </div>
                                </div>

                                <div className="sm:col-span-3">
                                    <label htmlFor="last-name" className="block text-sm/6 font-medium text-gray-900">
                                        Nom * / Lastname *
                                    </label>
                                    <div className="mt-2">
                                        <FormsComponent.Input id="lastName" label="Nom" value={formBuyer.lastName} onChange={(e) => setFormBuyer({ ...formBuyer, lastName: e })} />
                                    </div>
                                </div>

                                <div className="sm:col-span-4">
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Email * / Email *
                                    </label>
                                    <div className="mt-2">
                                        <FormsComponent.Input id="email" label="Email" value={formBuyer.email} onChange={(e) => setFormBuyer({ ...formBuyer, email: e })} />
                                    </div>
                                </div>

                                <div className="sm:col-span-3">
                                    <label htmlFor="country" className="block text-sm/6 font-medium text-gray-900">
                                        Pays * / Country *
                                    </label>
                                    <div className="mt-2 grid grid-cols-1">
                                        <select id="country" label="Pays" className="border block w-full sm:text-xs border-gray-300 rounded-md h-8 px-3 text-xs"
                                            onChange={(e) => {
                                                setFormBuyer({ ...formBuyer, country: e.target.value })
                                            }}
                                            value={formBuyer.country}>
                                            <option value=""></option>
                                            {countrycodes.map(c => { return { label: c.name, value: c["country-code"] } }).map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                                        </select>
                                    </div>
                                </div>

                                <div className="col-span-full">
                                    <label htmlFor="street-address" className="block text-sm/6 font-medium text-gray-900">
                                        Adresse * / Address *
                                    </label>
                                    <div className="mt-2">
                                        <FormsComponent.Input id="adress1" label="Adresse" value={formBuyer.adress1} onChange={(e) => setFormBuyer({ ...formBuyer, adress1: e })} />
                                    </div>
                                </div>

                                <div className="sm:col-span-2 sm:col-start-1">
                                    <label htmlFor="city" className="block text-sm/6 font-medium text-gray-900">
                                        Ville * / City *
                                    </label>
                                    <div className="mt-2">
                                        <FormsComponent.Input id="city" label="Ville" value={formBuyer.city} onChange={(e) => setFormBuyer({ ...formBuyer, city: e })} />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="postal-code" className="block text-sm/6 font-medium text-gray-900">
                                        Code postal * / Zip Code *
                                    </label>
                                    <div className="mt-2">
                                        <FormsComponent.Input id="zipCode" label="Code postal" value={formBuyer.zipCode} onChange={(e) => setFormBuyer({ ...formBuyer, zipCode: e })} />
                                    </div>
                                </div>
                            </div>
                            : <div>
                                <div>
                                    {formBuyer.firstName}{" "}{formBuyer.lastName}{" "}( {formBuyer.email} )
                                </div>
                                <div>
                                    {formBuyer.adress1}{" "}{formBuyer.adress2}{" "}{formBuyer.zipCode}{" "}{formBuyer.city}{" "}( {countrycodes.find(c => c["country-code"] === formBuyer.country).name} )
                                </div>
                            </div>}
                    </div>
                    {!lockInfo && <div className="flex items-center justify-center  text-white  bg-primary-perso w-full  rounded-full cursor-pointer z-10 " onClick={getParameters}>
                        <div className=" py-2" style={{ lineHeight: "16px", fontSize: "16px" }}>
                            {t("Enregistrer / Save")}
                        </div>
                    </div>}
                </form>
            </div>
            <div className="flex items-center justify-center my-8">
                {payboxParameters && lockInfo ?
                    <form method="POST" action={payboxParameters.options.find(opt => opt.label === "url")?.value?.split(" ")[0]}>
                        {payboxParameters.options.filter(opt => opt.label !== "url").sort((a, b) => parseFloat(a.displayOrder) - parseFloat(b.displayOrder)).map(opt => <input type="hidden" name={opt.label} value={opt.value} />)}
                        <button className="flex items-center justify-center  text-white  bg-primary-perso w-full  rounded-full cursor-pointer py-2" style={{ lineHeight: "16px", fontSize: "16px" }} type="submit">{t("Procéder au paiement / Proceed to payment")}</button>
                    </form> : null
                }
                {
                    lockInfo && !payboxParameters ? <LoadingSpinner /> : null
                }
            </div>

        </div> : null)
        }
    </div > : null
}

export default withTranslation()(Paybox);